import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchParams } from '../searchParams';
import { SearchResults } from '../searchResults';
import { Lawyer, LawyerLite, LawyerTiny } from './lawyer';


@JsonObject('LawyerSearchResults')
export class LawyerSearchResults extends SearchResults {
    @JsonProperty('results', [Lawyer])
    results: Lawyer[] = [];
}

@JsonObject('LawyerSearchResultsLite')
export class LawyerSearchResultsLite extends SearchResults {
    @JsonProperty('results', [LawyerLite])
    results: LawyerLite[] = [];
}

@JsonObject('LawyerSearchResultsTiny')
export class LawyerSearchResultsTiny extends SearchResults {
    @JsonProperty('results', [LawyerTiny])
    results: LawyerTiny[] = [];
}

@JsonObject('LawyerSearchParams')
export class LawyerSearchParams extends SearchParams {
    @JsonProperty('date', String)
    date: string = null;
}

